import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withKeys as _withKeys } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["placeholder", "onKeydown"]
const _hoisted_3 = { class: "v-input__error" }

import { replace } from '@/utils/vue';
import { reactive, watch } from 'vue';
import CloseIcon from './icons/navigation/CloseIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VInputTags',
  props: {
    modelValue: null,
    label: null,
    placeholder: null,
    error: null,
    highlightWord: null
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as { 
  modelValue?: string[], 
  label?: string, 
  placeholder?: string, 
  error?: string,
  highlightWord?: string
}




const words = reactive<string[]>(props.modelValue || [])

const addWord = (e: Event) => {
  const input = (e.currentTarget as HTMLInputElement)

  let splited = input.value.split(",")
  let addedWords = 0;
  for (let _word of splited) {
    const word = _word.trim()
    if (!word) continue
    if (words.includes(word)) continue
    words.push(word)
    addedWords++
  }
  if (addedWords === 0) return
  
  input.value = ""
  emit("update:modelValue", words)
}

const removeWord = (index: number) => {
  words.splice(index, 1)
  emit("update:modelValue", words)
}

watch(() => props.modelValue, () => {
  if (!props.modelValue || props.modelValue === words) return
  replace(words, props.modelValue)
  emit("update:modelValue", words)
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["v-input-tags", { errored: !!props.error }])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(words, (word, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["v-input-tags__tag", { highlight: props.highlightWord && props.highlightWord === word }])
      }, [
        _createTextVNode(_toDisplayString(word) + " ", 1),
        _createElementVNode("button", {
          onClick: ($event: any) => (removeWord(index))
        }, [
          _createVNode(CloseIcon)
        ], 8, _hoisted_1)
      ], 2))
    }), 256)),
    _createElementVNode("input", {
      placeholder: props.placeholder,
      onKeydown: _withKeys(addWord, ["enter"]),
      onBlur: addWord
    }, null, 40, _hoisted_2),
    _createElementVNode("div", _hoisted_3, _toDisplayString(props.error), 1)
  ], 2))
}
}

})